import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from "react";
import { TypeRampV2 } from "../../../typography";
import { DatePickerDayButtonStyled } from "../styled/DatePickerDayButtonStyled";
import { getTypeRampPropsDay } from "../styled/datePickerTheme";
export const DAY_STYLED_CLASS_NAME = "lodestar-core--date-picker--day-h3kj2h1";
export const DatePickerDay = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(DatePickerDayButtonStyled, _extends({}, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(TypeRampV2, _extends({
    className: DAY_STYLED_CLASS_NAME
  }, getTypeRampPropsDay(rest.themeMode)), children));
});
DatePickerDay.displayName = "DatePickerDay";
//# sourceMappingURL=DatePickerDay.js.map